import axios from "axios";

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getSource = () => {
  try {
    const p = new URLSearchParams(window.location.search);
    const s = p.get("utm_source") || p.get("src");
    if (s) {
      sessionStorage.setItem("aih_source", s);
      return s;
    }
    return sessionStorage.getItem("aih_source") || "direct";
  } catch (e) {
    return "direct";
  }
};

export const track = (event, meta) => {
  try {
    axios.post(`${API_BASE}/track`, { event, source: getSource(), meta });
  } catch (e) {
    /* analytics must never break the page */
  }
};
